import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Hook to track page views with Google Analytics in a SPA
 * This sends pageview events to GA4 whenever the route changes
 */
const useGoogleAnalytics = () => {
  const location = useLocation();
  
  useEffect(() => {
    // Check if gtag is available
    if (window.gtag) {
      // Send pageview event to Google Analytics
      window.gtag('config', 'G-937EVF4D0V', {
        page_path: location.pathname + location.search
      });
    }
  }, [location]);
};

export default useGoogleAnalytics;
